<template>
  <v-container fluid>
    <v-row class="d-flex justify-center">
      <v-col
        sm="12"
        md="3"
      >
        <players-container
          :icon-schedule="playerName"
          :players-item="playersItem"
          @playerSelected="playerSelectedChanged"
        />
      </v-col>
      <v-col
        sm="12"
        :md="calendarVisible ? 5 : 9"
      >
        <schedules-grid
          ref="scheduleGrid"
          :disable-add="disableAddSchedule"
          :has-changed="unsavedChange"
          :header="sharedPlayerMsg"
          :players-selected="playerSelected"
          :schedule-list.sync="schedules"
          :schedule-list-full.sync="unsharedSchedules"
          :while-time="whileTime"
          @empty-schedule="emptySchedule"
          @iconOn="setIconOn"
          @newSchedule="formScheduleOverlay = !formScheduleOverlay"
          @scheduleAdded="newSchedule"
          @loopState="loopLimit"
          @open-calendar="openCalendar"
          @uploadSchedule="uploadSchedule"
          @refresh="refresh"
        />
      </v-col>
      <v-col
        v-if="calendarVisible"
        sm="12"
        md="4"
      >
        <schedule-calendar :schedule="schedules" />
      </v-col>
    </v-row>
    <button-dialog-delete
      :icon="false"
      :text="$t('popup.schedule')"
      @ok-pushed="deleteSchedule()"
    />
    <dialog-upload
      :text="$t('schedule.update')"
      :open-dialog="openDialogUpload"
    />
    <dialog-leave
      ref="dialogLeave"
      :btn-txt1="$t('dialog.save-send')"
      :btn-txt2="$t('dialog.not-save')"
      :btn-txt3="$t('dialog.cancel')"
      :msg="$t('dialog.save-schedule-label')"
      :subtitle="$t('dialog.save-subtitle')"
      :title="$t('appname')"
    />
  </v-container>
</template>

<script>
// Components
import buttonDialogDelete from "./Common/ButtonDialogDelete";
import dialogLeave from "./Dialog/DialogLeave";
import dialogUpload from "./Dialog/DialogUpload";
import playersContainer from "./SchedulePage/PlayersContainer";
import schedulesGrid from "./SchedulePage/SchedulesGrid";
import scheduleCalendar from "./Common/ScheduleCalendar";

// Controllers
import { ScheduleManager } from "./SchedulePage/ScheduleManager";
import { ScheduleFileMaker } from "./SchedulePage/ScheduleFileMaker";
import { ScheduleReader } from "./SchedulePage/ScheduleReader";

// Connectors
import { PlayerConnector } from "./Database/PlayerConnector";
import { ProfileMailTransferConnector } from "./Database/ProfileMailTransferConnector";
import { ProfileViewerConnector } from "./Database/ProfileViewerConnector";
import { ScheduleConnector } from "./Database/ScheduleConnector";

// Tools
const ft = require("./Tools/FileTools");
const sqlTool = require("./Tools/SQLTools");

export default {
  components: {
    buttonDialogDelete,
    dialogLeave,
    dialogUpload,
    playersContainer,
    schedulesGrid,
    scheduleCalendar,
  },
  data() {
    return {
      mailTransferConnector: new ProfileMailTransferConnector(this.$store.state.user),
      playerConnector: new PlayerConnector(this.$store.state.user),
      scheduleConnector: new ScheduleConnector(this.$store.state.user),
      viewerConnector: new ProfileViewerConnector(this.$store.state.user),
      formScheduleOverlay: false,
      playersItem: [],
      playerSelected: [],
      schedules: [],
      unsharedSchedules: [],
      sharedPlayerMsg: "",
      querySchedule: [], // TODO: remove this params
      queryScheduleFull: [], // TODO: remove this params
      minSchedulePlayer: [],
      senderData: [],
      listViewers: [],
      playerName: [],
      whileTime: 0,
      openDialogUpload: false,
      openDialogScheduleEdit: false,
      listPlayerSelected: "",
      unsavedChange: false,
      calendarVisible: false,
      mailData: { recipient: "", subject: "", text: "" },
    };
  },
  computed: {
    disableAddSchedule() {
      const writeSchedule = this.$store.state.user.permissions.indexOf(6) !== -1;
      return this.playerSelected.length == 0 || !writeSchedule;
    },
  },
  watch: {
    schedules: {
      handler(val) {
        // Check if unsaved change not already detected
        if (this.unsavedChange == false) {
          // If length different add or delete occured
          if (val.length != this.querySchedule.length) {
            console.info("modified length different");
            console.info("unsaved change");
            this.unsavedChange = true;
            return;
          } else {
            // Check each entity
            for (let i = 0; i < val.length; i++) {
              // Check if project id are in the same order and with the same property (date, time, days, permanent)
              if (!this.projectCompare(val[i], this.querySchedule[i])) {
                console.info("unsaved change");
                this.unsavedChange = true;
                return;
              }
            }
          }
        }
      },
      deep: true,
    },
  },
  created() {
    document.title = this.$t("navbar.schedule") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.schedule"));
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      // API CALLS
      this.getAllPlayers();
      //this.getSenderMailData();
    }
  },
  async beforeRouteLeave(to, from, next) {
    // If at least one player is selected and unsaved change at true
    if (this.playerSelected.length > 0 && this.unsavedChange) {
      // Create loopState
      let loopState = {
        state: false,
        time: "",
      };

      if (this.schedules.length > 0) {
        // Retrieve loopState
        loopState.state = this.schedules[0].loop_limit == 1;
        loopState.time = this.schedules[0].loop_duration;
      }

      // Wait for dialog response before
      const res = await this.dialogLeaveResponse();
      switch (res) {
        case 1:
          this.uploadSchedule(loopState);
          next(false);
          break;
        case 2:
          next();
          break;

        default:
          next(false);
          break;
      }
    } else {
      next();
    }
  },
  methods: {
    projectCompare(newSchedule, oldSchedule) {
      // Check same projects
      if (newSchedule.projectData.id_proj != oldSchedule.proj_id) {
        console.info("project different");
        return false;
      }

      // Check same date from
      if (newSchedule.dateFrom !== null && oldSchedule.fromDate !== null) {
        if (newSchedule.dateFrom.substring(0, 10) != oldSchedule.fromDate.substring(0, 10)) {
          console.info("date from different");
          return false;
        }
      } else {
        if (newSchedule.dateFrom !== oldSchedule.fromDate) {
          console.info("date from different (null)");
          return false;
        }
      }

      // Check same date to
      if (newSchedule.dateTo !== null && oldSchedule.toDate !== null) {
        if (newSchedule.dateTo.substring(0, 10) != oldSchedule.toDate.substring(0, 10)) {
          console.info("date to different");
          return false;
        }
      } else {
        if (newSchedule.dateTo !== oldSchedule.toDate) {
          console.info("date to different (null)");
          return false;
        }
      }

      // Check same time from
      if (newSchedule.timeFrom !== null && oldSchedule.fromTime !== null) {
        if (newSchedule.timeFrom.substring(0, 5) != oldSchedule.fromTime.substring(0, 5)) {
          console.info("time from different");
          return false;
        }
      } else {
        if (newSchedule.timeFrom !== oldSchedule.fromTime) {
          console.info("time from different (null)");
          return false;
        }
      }

      // Check same time to
      if (newSchedule.timeTo !== null && oldSchedule.toTime !== null) {
        if (newSchedule.timeTo.substring(0, 5) != oldSchedule.toTime.substring(0, 5)) {
          console.info("time to different");
          return false;
        }
      } else {
        if (newSchedule.timeTo !== oldSchedule.toTime) {
          console.info("time to different (null)");
          return false;
        }
      }

      // Check same days
      if (
        newSchedule.days[0].active != oldSchedule.mon ||
        newSchedule.days[1].active != oldSchedule.tue ||
        newSchedule.days[2].active != oldSchedule.wed ||
        newSchedule.days[3].active != oldSchedule.thu ||
        newSchedule.days[4].active != oldSchedule.fri ||
        newSchedule.days[5].active != oldSchedule.sat ||
        newSchedule.days[6].active != oldSchedule.sun
      ) {
        console.info("day different");
        return false;
      }

      return true;
    },
    async collectScheduleForPlayers() {
      // TODO: MAKE A FUNCTION REEUSE IN MULTIPLE PLACES
      const players = this.playerSelected.map((player) => {
        return player.plyrID;
      });

      this.schedules = [];
      this.queryScheduleFull = [];
      this.querySchedule = [];
      this.querySchedule = await this.scheduleConnector.collectScheduleForPlayers(players);

      if (this.playerSelected.length > 1) {
        this.queryScheduleFull = await this.scheduleConnector.unsharedSchedule(players, this.querySchedule.length);

        if (this.querySchedule.length) {
          this.minSchedulePlayer = await this.scheduleConnector.collectMinScheduleForPlayers(players);

          if (this.minSchedulePlayer[0] !== undefined) {
            this.gatherScheduleID();
          }
        }
      }

      if (this.querySchedule.length > 0 || this.minSchedulePlayer.length > 0 || this.queryScheduleFull.length > 0) {
        this.gatherScheduleName();

        if (this.queryScheduleFull) {
          this.unsharedSchedules = this.queryScheduleFull;
          this.unsharedSchedules.sort(function (a, b) {
            return a.rank - b.rank;
          });
        }

        // this.querySchedule is defined sure false if there is no common
        if (this.querySchedule) {
          this.querySchedule.sort(function (a, b) {
            return a.rank - b.rank;
          });

          let tmpSchedules = [];
          // await this.querySchedule.forEach(async (scheduleSQL) => {
          //   let scheduleToPush = await sqlTool.convertScheduleSQLToJS(scheduleSQL)
          //   tmpSchedules.push(scheduleToPush);
          // });
          //remplacé par : (pour éviter le forEach asynchrone)
          for (let scheduleSQL of this.querySchedule) {
            let scheduleToPush = await sqlTool.convertScheduleSQLToJS(scheduleSQL);
            tmpSchedules.push(scheduleToPush);
          }
          this.schedules = tmpSchedules;

          if (this.schedules.length > 0) {
            let lState = this.schedules[0].loop_limit == 1;
            let lTime = this.schedules[0].loop_duration;

            if (lState && lTime > 0) {
              this.whileTime = Math.round(lTime / this.schedules.length);
            }
          }
        }
      }
    },
    checkSharedPlayer() {
      this.playerConnector.checkSharedPlayer(this.playerSelected).then((sharedPlayer) => {
        if (sharedPlayer.length > 1) {
          this.sharedPlayerMsg = this.$t("schedule.shared-player") + " ";
          sharedPlayer.forEach((player) => {
            this.sharedPlayerMsg += player.name + ", ";
          });
          this.sharedPlayerMsg = this.sharedPlayerMsg.replace(/, $/, "");
        }
      });
    },
    dialogLeaveResponse() {
      return new Promise((resolve) => {
        this.$refs.dialogLeave.openDialog();
        // TODO: WTF watch a refs !!!
        this.$refs.dialogLeave.$watch("response", (val) => {
          if (val > 0) {
            resolve(val);
          }
        });
      });
    },
    refresh() {
      this.collectScheduleForPlayers();
    },
    emptySchedule() {
      // Schedule cleared
      console.info("schedule cleared");
      console.info("unsaved change");
      this.unsavedChange = true;

      // TODO: MAKE A FUNCTION REEUSE IN MULTIPLE PLACES
      const players = this.playerSelected.map((player) => {
        return player.plyrID;
      });

      this.scheduleConnector.emptyScheduleForEachPlayer(players).then(() => {
        this.schedules = [];
        this.unsharedSchedules = [];
      });
    },
    getAllPlayers() {
      // Get all players
      this.playerConnector.createGroupAll().then((allGroup) => {
        let allPlayers = allGroup;

        // Add translation for player group all
        allPlayers[0].name = this.$t("dialog.all");

        // Get players grouped
        this.playerConnector.getAllPlayersGrouped().then((otherGroups) => {
          // Avengers assemble
          this.playersItem = allPlayers.concat(otherGroups);

          // TODO: REWORK NEEDED ? Correct all ids to make sure they're different
          let p = 1;
          this.playersItem.forEach((group) => {
            group.children.forEach((player) => {
              player.id = p;
              p++;
            });
          });
        });
      });
    },
    newSchedule(val) {
      // New schedule added
      console.info("project added");
      console.info("unsaved change");
      this.unsavedChange = true;

      // TODO: MAKE A FUNCTION REEUSE IN MULTIPLE PLACES
      const players = this.playerSelected.map((player) => {
        return player.plyrID;
      });

      val.projectData.path = ft
        .replaceBackSlashFromPath(val.projectData.path)
        .replace(this.$store.state.config.dirs.root, "");

      this.scheduleConnector
        .addScheduleForPlayers(players, val, val.projectData)
        .then(() => {
          this.refresh();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setIconOn(player) {
      this.playerSelected.forEach((players) => {
        players.color = 0;
      });

      this.playerName = player;
    },
    openCalendar(isVisible) {
      this.calendarVisible = isVisible;
    },
    loopLimit(loopState) {
      this.whileTime = 0;

      // TODO: MAKE A FUNCTION REEUSE IN MULTIPLE PLACES
      const players = this.playerSelected.map((player) => {
        return player.plyrID;
      });

      this.scheduleConnector
        .limitLoopTimeForPlayer(loopState, this.schedules, players)
        .then(() => {
          this.refresh();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async uploadSchedule(loopState) {
      const _this = this;
      console.info("save change");
      this.unsavedChange = false;

      // TODO: MAKE A FUNCTION REEUSE IN MULTIPLE PLACES
      const players = this.playerSelected.map((player) => {
        return player.plyrID;
      });

      // Open dialog upload
      this.openDialogUpload = true;

      // Update DB
      await this.scheduleConnector.updateSchedulesInfo(this.schedules, this.unsharedSchedules);
      await this.scheduleConnector.limitLoopTimeForPlayer(loopState, this.schedules, players);

      // Foreach player selected
      this.playerSelected.forEach((player) => {
        // Retrieve player license by player id
        this.playerConnector
          .getLicenseId(player.plyrID)
          .then((playerLicense) => {
            // Get schedule for all players ?
            this.scheduleConnector.collectScheduleForPlayers(players, true).then((querySchedule) => {
              let schedulesReader = [];
              querySchedule.forEach((scheduleSQL) => {
                if (player.plyrID == scheduleSQL.plyr_id) {
                  const convertPromise = new Promise((resolve) => {
                    const result = sqlTool.convertScheduleSQLToJS(scheduleSQL, true);
                    resolve(result);
                  });

                  convertPromise
                    .then((value) => {
                      schedulesReader.push(new ScheduleReader(value, null, this.$store.state.user));
                      if (schedulesReader.length * this.playerSelected.length >= querySchedule.length) {
                        schedulesReader.sort(function (a, b) {
                          return a.schedule.projectData.soc_id - b.schedule.projectData.soc_id;
                        });

                        schedulesReader.sort(function (a, b) {
                          return a.schedule.projectData.rank - b.schedule.projectData.rank;
                        });

                        const scheduleManager = new ScheduleManager(schedulesReader);

                        const scheduleFileMaker = new ScheduleFileMaker();
                        scheduleFileMaker
                          .init(scheduleManager, player.name, playerLicense, this.$store.state.user)
                          .then((fileMaker) => {
                            fileMaker.make().then(() => {
                              // AUTOCLOSE DIALOG
                              setTimeout(function () {
                                _this.openDialogUpload = false;
                              }, 3 * 1000);
                            });
                          });
                      }
                    })
                    .catch((err) => {
                      console.error(err);
                    });
                }
              });
            });
          })
          .catch((err) => {
            console.error("Player license not found:", err);
          });
      });

      // TODO: Not used
      /*
        if(this.senderData.length !== 0 && this.senderData.enable !== 0) { // if senderData.length === 0 => the sender email address is not specified
          this.sendMail();
        }
        */
    },
    gatherScheduleID() {
      let tempo = [];
      if (!this.queryScheduleFull) {
        this.queryScheduleFull = [];
      }

      this.queryScheduleFull.sort(function (a, b) {
        return a.id_sched - b.id_sched;
      });

      this.queryScheduleFull.sort(function (a, b) {
        return a.proj_id - b.proj_id;
      });

      this.minSchedulePlayer.forEach((minSchedule) => {
        for (let i = 0; i < this.playerSelected.length; i++) {
          let a = 0;
          let j = 0;
          let find = false;
          while (j < this.querySchedule.length && !find) {
            if (
              a < minSchedule.min &&
              this.playerSelected[i].plyrID == this.querySchedule[j].plyr_id &&
              minSchedule.proj_id == this.querySchedule[j].proj_id
            ) {
              if (a >= minSchedule.min) {
                find = true;
              }

              let k = 0;
              let findF = false;

              while (k < this.queryScheduleFull.length && !findF) {
                if (
                  this.querySchedule[j].path == this.queryScheduleFull[k].path &&
                  this.querySchedule[j].name == this.queryScheduleFull[k].name &&
                  this.querySchedule[j].proj_id == this.queryScheduleFull[k].proj_id
                ) {
                  this.queryScheduleFull.splice(k, 1);
                  findF = true;
                  k--;
                }
                k++;
              }
              tempo.push({ id: a, schedule: this.querySchedule[j] });
              a++;
            }
            j++;
          }
        }
      });
      tempo.sort(function (a, b) {
        return a.schedule.id_sched - b.schedule.id_sched;
      });
      tempo.sort(function (a, b) {
        return a.id - b.id;
      });
      tempo.sort(function (a, b) {
        return a.schedule.proj_id - b.schedule.proj_id;
      });

      let currentProj = 0;
      let currentPos = 0;
      for (let k = 0; k < this.minSchedulePlayer.length; k++) {
        if (this.minSchedulePlayer[k - 1] !== undefined) {
          currentPos += this.minSchedulePlayer[k - 1].min * this.playerSelected.length;
        }
        let currentId = 0;
        for (let i = 0; i < this.minSchedulePlayer[k].min; i++) {
          if (currentProj < tempo.length) {
            if (currentId == tempo[currentProj].id) {
              for (
                let j = currentPos;
                j <= currentPos + this.minSchedulePlayer[k].min * this.playerSelected.length;
                j++
              ) {
                if (tempo[currentProj] !== undefined && tempo[j] !== undefined) {
                  if (
                    currentProj != j &&
                    tempo[currentProj].id == tempo[j].id &&
                    tempo[currentProj].schedule.proj_id == tempo[j].schedule.proj_id
                  ) {
                    tempo[currentProj].schedule.group.push(tempo[j].schedule.group[0]);
                    currentPos--;
                    tempo.splice(j, 1);
                    j--;
                  }
                }
              }
            }
            currentId++;
          }
          currentProj++;
        }
      }

      tempo.sort(function (a, b) {
        return a.schedule.rank - b.schedule.rank;
      });

      for (let i = 0; i < tempo.length; i++) {
        tempo[i] = tempo[i].schedule;
      }
      this.querySchedule = tempo;
    },
    gatherScheduleName() {
      for (let i = 0; i < this.queryScheduleFull.length; i++) {
        this.queryScheduleFull[i].path = this.queryScheduleFull[i].path.split("/").pop().replace(/.zip$/, "");

        for (let j = 1; j < this.queryScheduleFull.length; j++) {
          if (this.queryScheduleFull[i].proj_id !== undefined && this.queryScheduleFull[j].proj_id !== undefined) {
            if (i != j && this.queryScheduleFull[i].proj_id == this.queryScheduleFull[j].proj_id) {
              if (!this.queryScheduleFull) {
                this.queryScheduleFull = [];
              }
              if (this.queryScheduleFull[i].name[0].length == 1) {
                this.queryScheduleFull[i].name = {
                  0: this.queryScheduleFull[i].name,
                  1: this.queryScheduleFull[j].name,
                };
              } else {
                let tempo2 = Object.values(this.queryScheduleFull[i].name);
                tempo2.push(this.queryScheduleFull[j].name);
                this.queryScheduleFull[i].name = tempo2;
              }
              this.queryScheduleFull.splice(j, 1);
              j--;
            }
          }
        }
      }
    },
    getSenderMailData() {
      // TODO: voir si on récupère le mail data en fonction de mailVerification dans le store
      this.mailTransferConnector
        .getSenderMailData()
        .then((data) => {
          this.senderData = data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getListViewers() {
      this.makeListPlayerSelected();

      this.viewerConnector.getViewersMail(this.listPlayerSelected).then((viewers) => {
        this.listViewers = viewers;
      });
    },
    makeListPlayerSelected() {
      // create a string : "plyrID|plyrID|...."
      this.listPlayerSelected = "";
      for (let i = 0; i < this.playerSelected.length; i++) {
        if (i === this.playerSelected.length - 1) {
          this.listPlayerSelected += this.playerSelected[i].plyrID;
        } else {
          this.listPlayerSelected += this.playerSelected[i].plyrID + "|";
        }
      }
    },
    playerSelectedChanged(val) {
      this.unsharedSchedules = [];
      this.schedules = [];
      this.sharedPlayerMsg = "";
      this.playerSelected = val;

      // On player select change reset unsaved change
      console.info("reset unsaved change");
      this.unsavedChange = false;

      if (val.length == 0) {
        // Clear schedule list done with "this.schedules=[]"
        return;
      } else {
        this.refresh();
        this.checkSharedPlayer();
      }
    },
    // TODO: à vérifier une fois l'envoie de mail remis sur le serveur
    sendMail() {
      this.getListViewers();

      this.mailData.subject = this.$t("profile.sections.mail-transfer.mail-subject");
      this.mailData.text = this.$t("profile.sections.mail-transfer.connection-link");
      for (let i = 0; i < this.listViewers.length; i++) {
        this.mailData.recipient = this.listViewers[i].login;
        this.mailTransferConnector.sendMail(this.senderData, this.mailData).catch((err) => {
          console.error(err);
          this.senderData.enable = 0;
          this.$store.dispatch("mailVerified", false);
          this.mailTransferConnector.disableSenderMail();
          return false;
        });
      }
    },
  },
};
</script>

<style></style>
